import angular from 'angular';
import exitCompliance from './exitCompliance';
import './style.scss';

export default angular
  .module('components.exitCompliance', [])
  .component('exitCompliance', exitCompliance).name;
